export default __webpack_public_path__ + "static/media/talkback@3x.a1efe717.png";